import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function PhysicalEducation() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Academics › Physical Education</p>
                <h1>Physical Education</h1>
                <p>Promoting fitness, sportsmanship, and holistic well-being among students.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>Department Overview</h2>
                    <p>
                        The Department of Physical Education and Gymkhana at Shri Mulikadevi Mahavidyalaya, Nighoj, plays a vital role in the physical and personality development of students. The department organizes various sports events, yoga sessions, and fitness programs throughout the academic year.
                    </p>
                </div>
                <div className="cards-grid">
                    {['Cricket', 'Volleyball', 'Kabaddi', 'Athletics (Track & Field)', 'Yoga', 'Indoor Games',].map(s => (
                        <div className="grid-card" key={s}><h3>🏅 {s}</h3></div>
                    ))}
                </div>
                <div className="info-card" style={{ marginTop: '1.5rem' }}>
                    <h2>Facilities</h2>
                    <ul>
                        <li>Open playground for cricket, volleyball, and kabaddi</li>
                        <li>Dedicated yoga and meditation area</li>
                        <li>Indoor games room (chess, table tennis)</li>
                        <li>Sports equipment storage and distribution facility</li>
                    </ul>
                </div>
                <div className="info-card">
                    <h2>Achievements</h2>
                    <p>Students from this department have represented at district, state, and national-level competitions, bringing laurels to the college. The Gymkhana actively encourages student participation in inter-college tournaments organized by Savitribai Phule Pune University.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default PhysicalEducation;
